module.exports = __webpack_public_path__ + "img/MHFisio-G.fe8ea853.png";